module.exports = __webpack_public_path__ + "img/金卡.88f97e7f.png";